export const isInvitationAlive = (invitation) =>
  invitation?.state === "Initial" || invitation?.state === "Establishing";

export const invitationRequiresReliableProgress = (invitation) =>
  invitation?.rel100 === "required";

/**
 * INVITE body is a raw SDP string in sip.js (not { content }).
 */
export const invitationHasSdpOffer = (invitation) => {
  const body = invitation?.body ?? invitation?.request?.body;
  if (typeof body === "string") {
    return body.trim().length > 0;
  }
  if (body && typeof body.content === "string") {
    return body.content.trim().length > 0;
  }
  return false;
};

/**
 * After any provisional response, sip.js attaches an early dialog.
 * For INVITE-with-SDP, that dialog is usually HaveRemoteOffer (not Initial).
 * accept() can answer via dialog.offer, but clearing non-Stable early dialogs
 * forces answer generation from the original INVITE body — more reliable on UCM.
 *
 * Do NOT clear Stable (183+SDP already completed offer/answer).
 */
export const clearBrokenEarlyDialog = (invitation) => {
  if (!invitation || !invitationHasSdpOffer(invitation)) {
    return false;
  }
  const dialog = invitation.dialog || invitation._dialog;
  if (!dialog) {
    return false;
  }
  if (dialog.signalingState === "Stable") {
    return false;
  }
  invitation._dialog = undefined;
  return true;
};
